import PolicyFormStepsEnum from "../../../../enums/PolicyFormStepsEnum";

export default () => ({
  policy: null,
  renderableTabs: [],
  customer: null,
  policyId: null,
  customerId: null,
  coverage: false,
  insurer: false,
  person: false,
  loading: false,
  pageLoaded: false,
  attachables: {},
  activeStepId: PolicyFormStepsEnum.DETAILS,
  activeSectionId: undefined,
});
